<button
    class="{{
        size() == 'large' ? '~px-5/6 font-semibold' : 'px-5 font-medium'
    }}  disabled:bg-neutral-600 shadow-md py-2 rounded-full ~text-xs/base transition-[colors,transform] disabled:cursor-not-allowed"
    [attr.disabled]="disabled() ? true : null"
    type="{{ type() }}"
    [ngClass]="{
        'hover:scale-105': scaleOnHover(),
        'bg-white text-primary hover:bg-gray-200': variant() === 'secondary',
        'bg-primary text-white hover:bg-primary-darker':
            variant() === 'primary',
    }"
>
    <ng-content></ng-content>
</button>
